import styled from 'styled-components';
import { useAppDataSliceSelector } from '../../../store/modules/appData';
import { isDevicePC } from '../../../utils/util';
import FixedAD from '../FixedAD';

const MobileFixAD = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
`;

const ADWrapper = styled.div`
  width: 320px;
  height: 50px;
  background-color: white;
  overflow: hidden;
`;

export default function MobileBottomAD({ id }) {
  const appData = useAppDataSliceSelector();
  const isPCView = isDevicePC(appData.deviceType);

  if (isPCView === true) {
    return null;
  }
  return (
    <MobileFixAD>
      <ADWrapper>
        <FixedAD id={id} />
      </ADWrapper>
    </MobileFixAD>
  );
}
